/** En dev, désinscrit les SW laissés par d’anciennes configs PWA (cache .vite/deps corrompu). */
export async function unregisterServiceWorkersInDev(): Promise<void> {
  if (!import.meta.env.DEV) {
    return;
  }

  if (!('serviceWorker' in navigator)) {
    return;
  }

  const registrations = await navigator.serviceWorker.getRegistrations();

  await Promise.all(
    registrations.map(async (registration) => {
      const unregistered = await registration.unregister();

      if (unregistered) {
        // eslint-disable-next-line no-console
        console.info('[poc-app] Service worker désinscrit:', registration.scope);
      }
    }),
  );

  if (registrations.length > 0 && 'caches' in window) {
    const keys = await caches.keys();

    await Promise.all(
      keys
        .filter((key) => key.includes('workbox') || key.includes('vite') || key.includes('pwa'))
        .map((key) => caches.delete(key)),
    );
  }
}
